import {Component, Input, AfterViewInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {ChartConfiguration, ChartOptions, ChartType} from "chart.js";
import {NgChartsModule, BaseChartDirective} from "ng2-charts";
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-line-chart',
  standalone: true,
  imports: [
    NgChartsModule,
    NzSkeletonModule,
    CommonModule
  ],
  templateUrl: './line-chart.component.html',
  styleUrl: './line-chart.component.scss'
})
export class LineChartComponent implements AfterViewInit, OnDestroy {
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;
  public barChartType: ChartType = 'line';
  @Input() expanded: boolean = false;
  @Input() isMonitorMode: boolean = false;
  @Input() loading: boolean = false;
  @Input() public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'x',
    scales: {
      x: {title: {display: true, text: 'Mês'}, grid: {display: false}},
      y: {title: {display: true, text: ''}, grid: {display: true}}
    },
    plugins: {
      legend: {position: 'bottom'}
    }
  };
  @Input() public barChartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: []
  };
  public barChartLegend = true;
  public barChartPlugins = [];

  private resizeObserver: ResizeObserver | null = null;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(() => {
      this.resizeChart();
    });
    this.resizeObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  public resizeChart(): void {
    if (this.chart?.chart) {
      this.chart.chart.resize();
    }
  }
}
